<template>
	<!-- 学员详情 - 学员排课记录 -->
	<v-container style="padding: 0;">
		<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" no-data-text="暂无数据">
			<template v-slot:top>
				<v-row dense class="mt-n1 mb-n8">
					<v-col cols="12" class="d-flex flex-wrap">
						<div style="width: 230px;" class="mr-1">
							<v-select :items="classItems"  item-text="className" item-value="id" dense label="班级"
								outlined v-model="query.classId" />
						</div>	
						<div style="width: 150px;" class="mr-1">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="开始上课日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</div>
						<div style="width: 150px;" class="mr-1">
							<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="结束上课日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</div>
						<div style="width: 150px;" class="mr-1">
							<v-select :items="statusItems" v-model="query.status" item-text="statusName"
								item-value="id" label="状态" dense outlined></v-select>
						</div>
						<v-btn @click="queryClicked" color="info">查询</v-btn>
					</v-col>
				</v-row>
			</template>
			
			<!-- 表格内容区 -->
			<template v-slot:body="{ items }">
				<tbody>
				  <tr v-for="(item,index) in items" :key="item.id" :class="index % 2 == 0?'tr_one':'tr_two'">
					<td>{{ item.courseName }}</td>
					<td>{{ item.className }}</td>
					<td>{{ item.classDate }}</td>
					<td>{{item.timeFrom}}-{{item.timeTo}}</td>
					<td>{{ item.teacherName }}</td>
					<td>{{ item.roomName }}</td>
					<td>
						<span v-if="item.status =='1'"  style="color:#FF9100">待核销</span>
						<span v-if="item.status =='2'" >已核销</span>
						<span v-if="item.status =='3'" style="color:#43A047;">已顺延</span>
					</td>
					<td align="center">
						<v-btn small color="info" @click="showRecordView(item)">查看</v-btn>
					</td>
				  </tr>
				</tbody>
			</template>
			
		</v-data-table>
		<div class="pt-2">
			<v-row dense>
				<v-col cols="1" >
					<v-select :items="[10, 20, 50, 100]" @change="handleSizeChanged" dense hide-details label="每页数量"
						outlined v-model="query.size" />
				</v-col>
				<v-col cols="1" class="mt-2">
					<span>共{{data.total}}项</span>
				</v-col>
				<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
					<v-pagination :length="Math.ceil(data.total/query.size)" @input="handlePageChanged"
						total-visible="5" v-model="query.page" />
				</v-col>
			</v-row>
		</div>
		
		<!-- 课程详情组件 -->
		<recordView :show="recordView.show" :recordId="recordView.recordId" @cancel="recordView.show=false"></recordView>
	
	</v-container>
</template>

<script>
	import global from "../config/global"
	import recordView from "./record_info_view.vue"
	export default {
		name:"student-record-list",
		components:{recordView},
		props:{
			studentId:{
				type:String,
				default:""
			},
			classItems:{
				type:Array,
				default:[]
			},
			refreshData:{
				type:String,
				default:""
			}
		},
		watch:{
			// studentId(newVal,oldVal){
			// 	if (newVal&&newVal != oldVal){
					
					
			// 	}
			// },
			refreshData(newVal,oldVal){
				if (newVal&&newVal != oldVal){
					console.log(newVal);
					this.getDataList();
				}
			},
		},
		data(){
			return {
				menu1:false,
				menu2:false,
				query:{
					loading:false,
					page:1,
					size:10,
					classId:"",
					status:"",
					start:"",
					end:"",
					
				},
				selectedItems:[],
				statusItems:[
					{id:"",statusName:"全部"},
					{id:"1",statusName:"待核销"},
					{id:"2",statusName:"已核销"},
					{id:"3",statusName:"已顺延"},
				],
				weekItems:global.weekList,
				data: {
					total:0,
					headers:[
						{
							text: '课程',
							value: 'courseName',
							sortable: false
						},
						{
							text: '班级',
							value: 'className',
							sortable: false
						},
						{
							text: '上课日期',
							value: 'classDate',
							sortable: false
						},
						{
							text: '时间段',
							value: 'timeRange',
							sortable: false
						},
						{
							text: '老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '教室',
							value: 'roomName',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							align:'center',
							sortable: false
						},
					],
					list:[],
					
				},
				approve:{
					show:false,
					recordId:""
				},
				recordView:{
					show:false,
					recordId:""
				}
			}
		},
		mounted() {
			console.log("student-record-list mounted");

			this.getDataList();
		
		
		},
		methods:{
			queryClicked(){
				this.query.page = 1;
				this.getDataList();
			},
			handleSizeChanged(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getDataList();
			},
			handlePageChanged(page) {
				this.query.page = page;
				this.getDataList();
			},
			statusName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "待核销";
				} else if (state === "0") {
					stName = "已取消";
				}else if (state === "2") {
					stName = "已核销";
				}else if (state === "3") {
					stName = "已顺延";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "0") {
					color = "error";
				}else if (state === "2") {
					color = "success";
				}else if (state === "3") {
					color = "grey";
				}
			
				return color;
			},
			weekName(wk) {
			
				let stName = "未知";
				this.weekItems.forEach((item,index)=>{
					if (item.week == wk){
						stName = item.weekName;
					}
				})
				return stName;
			},
			getDataList(){
				const that = this;
				const studentId = this.studentId;
				let url = `/edu/student/${studentId}/record/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if(this.query.start){
					url += "&start="+this.query.start;
				}
				if(this.query.end){
					url += "&end="+this.query.end;
				}
				if(this.query.status){
					url += "&status="+this.query.status;
				}
				if(this.query.classId){
					url += "&classId="+this.query.classId;
				}
				that.data.list = [];
				that.data.total = 0;		
				this.axios.get(url).then(response => {		
					if (response.data["code"] === 200) {
						
						console.log(">>>>>>>>>>>获取学员课表>>>>>>>>>>>")
						console.log(response.data);
						console.log(">>>>>>>>>>>获取学员课表>>>>>>>>>>>")
						
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				})
			},
			showApprove(item){
				this.approve.recordId = item.id;
				this.approve.show = true;
			},
			approveSuccess(){
				// 核销成功
				this.approve.show=false;
				this.getDataList();
			},
			showRecordView(item){
				this.recordView.recordId = item.id;
				this.recordView.show = true;
			}
		}
	}
	
</script>


<style>
</style>
